// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".acc_content[data-v-f3f8309e]{width:1060px}", ""]);
// Exports
module.exports = exports;
